<template>
  <v-sheet :dark="dark" class="fill-height" :color="!dark ? 'background' : null">
    <page-header
      :banner-height="250"
      :banner="banner"
      back="dashboard"
      :dark="dark"
    >
      <template slot="hero">
        <v-avatar v-if="club.logo" class="app-btn" size="70">
          <v-img :src="club.logo"></v-img>
        </v-avatar>
        <h1 class="text-h5">{{ title }}</h1>
        </template>
     <template slot="icon">
      <v-btn class="app-btn" depressed fab small @click="toggleFavorite">
        <v-icon v-if="favorite">favorite</v-icon>
        <v-icon v-else>favorite_border</v-icon>
      </v-btn>
      </template>
    </page-header>
    <v-card
     tile
      class="mx-auto pb-15"
      flat
      color="transparent"
    >
  
    
    </v-card>
  </v-sheet>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PageHeader from "../components/PageHeader.vue";

export default {
  components: {
    PageHeader
  },
  data() {
    return {
      loading: true,
     
    };
  },
  computed: {
    ...mapGetters(["dark","club","user"]),
    favorite: {
      get() {
        return this.club._favorite;
      },
      set(value) {
        this.club._favorite = value;
      },
    },
    banner() {
      return this.club.banner || this.$config.page.banner;
    },
    title() {
      return this.club.name;
    },
  },
  mounted() {
    if (this.$store.state.token) {
      this.load();
    }
    
  },
  watch: {
    
  },
  methods: {
    ...mapActions(["setClub"]),
    async load(search) {
      
    },
    async toggleFavorite() {
      this.favorite = !this.favorite;
      if (this.favorite) {
        let response = await this.$http.post(
          "/api/edge/CONSUMERS/" + this.club._id,
          { _id: this.user._id, favorite: true, date: new Date() }
        );
      } else {
        let response = await this.$http.delete(
          "/api/edge/CONSUMERS/" + this.club._id,
          { _id: this.user._id }
        );
      }
    },
   
    
    
  },
};
</script>

